import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import axios from "axios";
import moment from "moment";
import { splitTeacherCourses } from "@/utils/teacherCourseSeparator";
import { pinyin } from "pinyin";

import { ElLoading } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/loading/style/css';
export default {
  data() {
    return {
      institution: sessionStorage.getItem("institution"),
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      todayDate: "",
      showStudentList: true,
      selectedStudentStatus: "全部",
      pendingDealStudentIds: [],
      // 学生列表
      studentList: [],
      oriStudentList: [],
      selectedStudentId: "",
      selectedStudentIndex: 0,
      searchStudentStr: "",
      // 可供选择的建议列表,所有学生名
      suggestions: [],
      // 根据输入过滤后的建议列表
      filteredSuggestions: [],
      // 学生 课程变动，金额异动，总课时，未消课时, 未消课时的金额
      studentChangeFee: {},
      // 学生 总缴费，总退费，剩余金额
      studentBalance: {},
      // 未消课时百分比
      courseHourDashArray: 0,
      courseHourDashOffset: 0,
      courseRestHourPercentage: 0,
      // 未消金额百分比
      balanceDashArray: 0,
      balanceDashOffset: 0,
      balancePercentage: 0,
      // 某个学生缴费记录
      studentPaymentList: [],
      // 某个学生课消记录
      studentAttendedCourseList: [],
      // 已消课时
      studentAttendedHours: 0,
      // 当日课消金额
      todayCourseFee: 0,
      //班级列表
      classList: [],
      oriClassList: [],
      //classId转换为className
      classNames: {},
      classType: {},
      // 顾问
      consultantList: [],
      consultantNames: {},
      selectedConsultantIndex: "",
      showAddPaymentConsultant: false,
      paymentConsultantForm: {
        name: "",
        phone: ""
      },
      showPaymentRecordDetail: false,
      selectedPaymentRecord: {},
      paymentRecordDetailCourses: [],
      // 老师列表
      teacherList: [],
      // teacherId转换为teacherName
      teacherNames: {},
      // 预存
      showPrepay: false,
      prepayAmount: "",
      formattedPrepayAmount: "",
      prepayDonateAmount: "",
      formattedPrepayDonateAmount: "",
      prepayTotalAmount: "",
      showPayMethod: false,
      showPaySuccess: false,
      paymentRemark: "",
      // 退费
      showSelectRefundClass: false,
      studentEnrollClassList: [],
      pendingRefundClassIds: [],
      showRefundDetail: false,
      selectedRefundClassId: "",
      selectedRefundClassIds: [],
      refundClassCourseTecherFeeObj: {},
      refundCourses: [],
      refundTotalFee: 0,
      refundRemainingTotal: 0,
      refundDonateAmount: 0,
      refundRealFee: 0,
      refundServiceFee: 0,
      refundReason: "",
      refundServiceFeeReason: "",
      pendingRefundApplyList: [],
      useOriFee: false,
      // 金额异动详情
      showChangeFeeExplain: false,
      showChangeFeeDetail: false,
      showChangeFeePayMethod: false,
      // 默认选择余额
      selectUseBalancePay: true,
      // 默认选择余额
      payMethod: "余额",
      balanceRemainPayMethod: "现金",
      tipResolver: null,
      showTip: false,
      tipMessage: "",
      tipNeedInput: false,
      tipInputText: "",
      // 添加学生
      showAddStudent: false,
      studentName: "",
      studentGrade: "",
      studentSchool: "",
      studentPhone: "",
      studentParentPhone: "",
      studentParentPhones: [""],
      phoneValidate: false,
      studentSource: "",
      editStudentFlag: false
    };
  },
  async mounted() {
    const mountT0 = performance.now();
    let stepT0 = mountT0;
    const logStep = label => {
      const t = performance.now();
      console.log(`[studentManagement mounted] ${label}: ${(t - stepT0).toFixed(1)}ms`);
      stepT0 = t;
    };
    this.todayDate = moment().format("YYYY-MM-DD");
    logStep("初始化 todayDate");
    await this.getClassList();
    logStep("getClassList");
    await this.getTeacherList();
    logStep("getTeacherList");
    await this.getStudentList();
    logStep("getStudentList");
    await this.getConsultantList();
    logStep("getConsultantList");
    if (this.institution == "得森") {
      // 获取待处理金额异动的学生数
      await this.getStudentChangeFeePendingDealNum();
    }
    logStep("getStudentChangeFeePendingDealNum（仅得森）");
    console.log(`[studentManagement mounted] 总用时: ${(performance.now() - mountT0).toFixed(1)}ms`);
  },
  methods: {
    //获取老师列表(筛选出启用的)
    async getTeacherList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution,
          flag: "onlyActive" //(筛选出启用的)
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/teacherAndCourse/getTeacherList", params);
        if (resp1.data.code == "0000") {
          this.teacherList = resp1.data.data;
          for (let i in this.teacherList) {
            this.teacherList[i].courses = splitTeacherCourses(this.teacherList[i].coursesStr);
          }

          // console.log("获取老师列表 this.teacherList:", this.teacherList);

          this.teacherNames = {};
          for (let i = 0; i < this.teacherList.length; i++) {
            this.teacherNames[this.teacherList[i].id] = this.teacherList[i].name;
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    // 获取学生列表
    async getStudentList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/getStudentList", params);
        if (resp1.data.code == "0000") {
          this.studentList = resp1.data.data;

          // console.log("获取学生列表:", this.studentList);

          this.oriStudentList = JSON.parse(JSON.stringify(this.studentList));
          this.suggestions = [];
          for (let i = 0; i < this.studentList.length; i++) {
            this.suggestions.push(this.studentList[i].name);
          }

          // 得到学生名首字母
          for (let i = 0; i < this.oriStudentList.length; i++) {
            this.oriStudentList[i].nameFirstLetter = pinyin(this.oriStudentList[i].name, {
              style: pinyin.STYLE_FIRST_LETTER
            })[0][0];
            this.studentList[i].nameFirstLetter = pinyin(this.studentList[i].name, {
              style: pinyin.STYLE_FIRST_LETTER
            })[0][0];

            // 如果是英文, 取第一个字母
            if (this.oriStudentList[i].nameFirstLetter.length > 1) {
              this.oriStudentList[i].nameFirstLetter = this.oriStudentList[i].nameFirstLetter.substring(0, 1);
            }
            if (this.studentList[i].nameFirstLetter.length > 1) {
              this.studentList[i].nameFirstLetter = this.studentList[i].nameFirstLetter.substring(0, 1);
            }

            // 大写字母
            this.oriStudentList[i].nameFirstLetter = this.oriStudentList[i].nameFirstLetter.toUpperCase();
            this.studentList[i].nameFirstLetter = this.studentList[i].nameFirstLetter.toUpperCase();
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 获取学生缴费记录
    async getStudentPaymentRecord() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          studentId: this.selectedStudentId
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/getStudentPaymentRecord", params);
        if (resp1.data.code == "0000") {
          this.studentPaymentList = this.normalizePaymentRecords(resp1.data.data);

          // console.log("获取学生缴费记录:", this.studentPaymentList);

          // 得到该条缴费记录的班级状态
          for (let i in this.studentPaymentList) {
            // 如果这条记录是 报名班级，获取班级进行状态
            if (this.studentPaymentList[i]["type"] == "payment" || this.studentPaymentList[i]["type"] == "balancePay") {
              // 如果不是报名班级，跳过
              if (!this.studentPaymentList[i].classId) {
                continue;
              }
              let classId = this.studentPaymentList[i].classId;
              let classIndex = this.classList.findIndex(item => item.id == classId);

              // console.log("classIndex:", classIndex);
              // console.log(
              //   "this.classList[classIndex]:",
              //   this.classList[classIndex]
              // );

              if (this.classList[classIndex].startDate > this.todayDate) {
                this.studentPaymentList[i].classStatus = "未开始";
              }
              if (this.classList[classIndex].startDate <= this.todayDate && this.classList[classIndex].endDate >= this.todayDate) {
                this.studentPaymentList[i].classStatus = "进行中";
              }
              if (this.classList[classIndex].endDate < this.todayDate) {
                this.studentPaymentList[i].classStatus = "已结班";
              }
            }
          }

          // 每条的时间格式化
          for (let i in this.studentPaymentList) {
            this.studentPaymentList[i].create_time = moment(this.studentPaymentList[i].create_time).utcOffset(8).format("YYYY-MM-DD HH:mm:ss");
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    getPaymentRecordTitle(item) {
      if (!item) return "缴费记录";
      if (item.payRemark == "金额异动") {
        return item.type == "balanceAdd" ? "金额异动退费，余额增加" : "金额异动缴费";
      }
      if (item.type == "balancePay" && item.classId) {
        return `余额报名“${this.classNames[item.classId] || `班级${item.classId}`}”`;
      }
      if (item.type == "payment" && item.classId) {
        return `报名“${this.classNames[item.classId] || `班级${item.classId}`}”`;
      }
      if (item.type == "prepay") return "预存";
      if (item.type == "refund") return "退费";
      return "缴费记录";
    },
    normalizePaymentRecords(records) {
      if (!Array.isArray(records)) return [];
      records = this.mergeMixedPaymentRecords(records);
      records = this.mergeBalanceAddPaymentRecords(records);
      records = this.attachBalanceDecreaseRemark(records);
      return records;
    },
    mergeMixedPaymentRecords(records) {
      const mergedRecordIds = new Set();
      const isMatchedMixedPayment = (balanceRecord, paymentRecord) => {
        if (paymentRecord.type != "payment" || paymentRecord.payRemark != "金额异动") {
          return false;
        }
        const balanceTime = moment(balanceRecord.create_time);
        const paymentTime = moment(paymentRecord.create_time);
        if (balanceTime.format("YYYY-MM-DD HH:mm:ss") == paymentTime.format("YYYY-MM-DD HH:mm:ss")) {
          return true;
        }
        return JSON.stringify(balanceRecord.enrollCourse || []) == JSON.stringify(paymentRecord.enrollCourse || []) && Math.abs(balanceTime.diff(paymentTime, "milliseconds")) <= 2000;
      };
      return records.map(record => {
        if (record.type != "balancePay" || record.payRemark != "金额异动" || !record.prepayId) {
          return record;
        }
        const matchedPayment = records.find(item => isMatchedMixedPayment(record, item));
        if (!matchedPayment) return record;
        mergedRecordIds.add(matchedPayment.id);
        return {
          ...record,
          amount: (Number(record.amount) || 0) + (Number(matchedPayment.amount) || 0),
          mixedBalanceAmount: Number(record.amount) || 0,
          mixedPaymentAmount: Number(matchedPayment.amount) || 0,
          consultantId: matchedPayment.consultantId,
          payMethod: matchedPayment.payMethod,
          mergedConsultantIds: this.getPrepayConsultantIds(record)
        };
      }).filter(record => !mergedRecordIds.has(record.id));
    },
    mergeBalanceAddPaymentRecords(records) {
      const balanceAddRecords = records.filter(item => item.type == "balanceAdd" && item.payRemark == "金额异动");
      const findMatchedBalanceAdd = prepayRecord => {
        const prepayTime = moment(prepayRecord.create_time).format("YYYY-MM-DD HH:mm:ss");
        return balanceAddRecords.find(item => {
          const itemTime = moment(item.create_time).format("YYYY-MM-DD HH:mm:ss");
          return itemTime == prepayTime && Number(item.amount) >= Number(prepayRecord.amount || 0);
        });
      };
      for (const record of records) {
        if (!(record.type == "prepay" && record.payRemark == "balanceAdd")) {
          continue;
        }
        const matchedRecord = findMatchedBalanceAdd(record);
        if (!matchedRecord) continue;
        if (!matchedRecord.mergedConsultantIds) {
          matchedRecord.mergedConsultantIds = [];
        }
        if (!matchedRecord.mergedPrepayAmounts) {
          matchedRecord.mergedPrepayAmounts = [];
        }
        if (record.consultantId && !matchedRecord.mergedConsultantIds.includes(record.consultantId)) {
          matchedRecord.mergedConsultantIds.push(record.consultantId);
        }
        matchedRecord.mergedPrepayAmounts.push({
          consultantId: record.consultantId,
          realAmount: Number(record.real_prepay) || 0,
          donateAmount: Math.max(0, (Number(record.amount) || 0) - (Number(record.real_prepay) || 0)),
          assumedAmount: Number(record.amount) || 0
        });
      }
      return records.filter(item => !(item.type == "prepay" && item.payRemark == "balanceAdd"));
    },
    attachBalanceDecreaseRemark(records) {
      const balancePayByPrepayId = new Map();
      for (const record of records) {
        if (record.type == "balancePay" && record.prepayId) {
          balancePayByPrepayId.set(Number(record.prepayId), record);
        }
      }
      return records.map(record => {
        if (!(record.type == "prepay" && record.payRemark == null && Number(record.amount) < 0)) {
          return record;
        }
        const linkedBalancePay = balancePayByPrepayId.get(Number(record.id));
        if (!linkedBalancePay) return record;
        let balanceUseRemark = "";
        if (linkedBalancePay.payRemark == "金额异动") {
          balanceUseRemark = "金额异动缴费";
        } else if (linkedBalancePay.classId) {
          balanceUseRemark = `报名“${this.classNames[linkedBalancePay.classId] || `班级${linkedBalancePay.classId}`}”`;
        }
        return {
          ...record,
          balanceUseRemark
        };
      });
    },
    getPrepayConsultantIds(item) {
      const prepayItems = this.parsePrepayIdAndAmount(item);
      return prepayItems.map(prepayItem => prepayItem.consultantId).filter((consultantId, index, arr) => consultantId && arr.indexOf(consultantId) == index);
    },
    parsePrepayIdAndAmount(item) {
      if (item && item.mergedPrepayAmounts) return item.mergedPrepayAmounts;
      if (!item || !item.prepayIdAndAmount) return [];
      if (Array.isArray(item.prepayIdAndAmount)) return item.prepayIdAndAmount;
      try {
        return JSON.parse(item.prepayIdAndAmount);
      } catch (error) {
        return [];
      }
    },
    getPaymentRecordConsultantText(item) {
      const prepayItems = this.parsePrepayIdAndAmount(item);
      const consultantIds = item && item.mergedConsultantIds && item.mergedConsultantIds.length ? item.mergedConsultantIds : prepayItems.map(prepayItem => prepayItem.consultantId).filter((consultantId, index, arr) => consultantId && arr.indexOf(consultantId) == index);
      if (consultantIds.length > 1) {
        return "多个顾问...";
      }
      if (consultantIds.length == 1) {
        return this.consultantNames[consultantIds[0]] || "";
      }
      return this.consultantNames[item.consultantId] || "";
    },
    getPaymentRecordConsultantTooltip(item) {
      const prepayItems = this.parsePrepayIdAndAmount(item);
      if (!prepayItems.length) return "";
      const consultantAmountMap = {};
      for (const prepayItem of prepayItems) {
        const consultantId = prepayItem.consultantId || "";
        if (!consultantId) continue;
        const realAmount = Number(prepayItem.realAmount) || 0;
        const donateAmount = Object.prototype.hasOwnProperty.call(prepayItem, "donateAmount") ? Number(prepayItem.donateAmount) || 0 : Math.max(0, Number(prepayItem.assumedAmount || 0) - realAmount);
        if (!consultantAmountMap[consultantId]) {
          consultantAmountMap[consultantId] = {
            realAmount: 0,
            donateAmount: 0
          };
        }
        consultantAmountMap[consultantId].realAmount += realAmount;
        consultantAmountMap[consultantId].donateAmount += donateAmount;
      }
      return Object.keys(consultantAmountMap).map(consultantId => {
        const amountInfo = consultantAmountMap[consultantId];
        const realAmount = parseFloat(amountInfo.realAmount.toFixed(2));
        const donateAmount = parseFloat(amountInfo.donateAmount.toFixed(2));
        const totalAmount = parseFloat((realAmount + donateAmount).toFixed(2));
        return `${this.consultantNames[consultantId] || consultantId}: ${totalAmount}金额（含${donateAmount}赠送金额）`;
      }).join("<br/>");
    },
    showPaymentRecordRightText(item) {
      return Boolean(this.getPaymentRecordRightText(item));
    },
    getPaymentRecordRightText(item) {
      if (!item) return "";
      if (item.type == "prepay" && item.payRemark == null && item.amount < 0) {
        return item.payRemarkDisplay || item.balanceUseRemark || "";
      }
      const consultantText = this.getPaymentRecordConsultantText(item);
      return consultantText ? `签约顾问: ${consultantText}` : "";
    },
    getPaymentRecordRightTooltip(item) {
      if (this.getPaymentRecordConsultantText(item) != "多个顾问...") {
        return "";
      }
      return this.getPaymentRecordConsultantTooltip(item);
    },
    getPaymentRecordConsultantNames(item) {
      if (item && item.mergedConsultantIds && item.mergedConsultantIds.length) {
        return item.mergedConsultantIds.map(consultantId => this.consultantNames[consultantId]).filter(Boolean).join("、");
      }
      return this.consultantNames[item.consultantId] || "";
    },
    showPaymentRecordDetailButton(item) {
      return !(item && item.type == "prepay" && item.payRemark == null && item.amount <= 0);
    },
    getPrepayRealAmount(item) {
      return Number(item && item.real_prepay) || 0;
    },
    getPrepayDonateAmount(item) {
      return parseFloat((Number(item && item.amount || 0) - this.getPrepayRealAmount(item)).toFixed(2));
    },
    getStudentBalanceDonateAmount() {
      if (this.studentBalance && Object.prototype.hasOwnProperty.call(this.studentBalance, "balanceDonateAmount")) {
        return Math.max(0, Number(this.studentBalance.balanceDonateAmount || 0));
      }
      return Math.max(0, Number(this.studentBalance.totalDonateAmount || 0));
    },
    getPaymentRecordDetailNote(item) {
      if (!item) return "";
      if (item.mixedBalanceAmount) {
        return `本次为余额和直接支付混合缴费：使用余额${item.mixedBalanceAmount} + 缴费${item.mixedPaymentAmount}`;
      }
      if (item.type == "prepay" && item.payRemark == null) {
        return `本次预存实际缴费${this.getPrepayRealAmount(item)}，赠送金额${this.getPrepayDonateAmount(item)}`;
      }
      return "";
    },
    openPaymentRecordDetail(item) {
      this.selectedPaymentRecord = item;
      let courses = item.enrollCourse || [];
      if (typeof courses == "string") {
        try {
          courses = JSON.parse(courses);
        } catch (error) {
          courses = [];
        }
      }
      this.paymentRecordDetailCourses = Array.isArray(courses) ? courses : [];
      this.showPaymentRecordDetail = true;
    },
    closePaymentRecordDetail() {
      this.showPaymentRecordDetail = false;
      this.selectedPaymentRecord = {};
      this.paymentRecordDetailCourses = [];
    },
    getPaymentCourseStandardFee(course) {
      // 同一课程ID的最早交易快照最接近学生锁价时的原价。
      // 历史调价曾覆盖 courseArrange.standardFee，不能直接用较新的快照。
      const records = [...this.studentPaymentList].reverse();
      for (const record of records) {
        let courses = record.enrollCourse || [];
        if (typeof courses == "string") {
          try {
            courses = JSON.parse(courses);
          } catch (error) {
            courses = [];
          }
        }
        if (!Array.isArray(courses)) continue;
        const historicalCourse = courses.find(item => String(item.id) === String(course.id));
        if (!historicalCourse) continue;
        const historicalFee = historicalCourse.courseFee ?? historicalCourse.standardFee;
        if (Number.isFinite(Number(historicalFee))) {
          return Number(historicalFee);
        }
      }
      const fee = course.courseFee ?? course.standardFee;
      return Number.isFinite(Number(fee)) ? Number(fee) : 0;
    },
    getPaymentCourseActualFee(course) {
      const feeMap = typeof course.studentFee == "string" ? (() => {
        try {
          return JSON.parse(course.studentFee);
        } catch (error) {
          return {};
        }
      })() : course.studentFee || {};
      const fee = feeMap[this.selectedStudentId] ?? course.realFee;
      return Number.isFinite(Number(fee)) ? Number(fee) : this.getPaymentCourseStandardFee(course);
    },
    getPaymentCourseChangeType(course) {
      if (course.isDelete || String(course.reason || "").includes("删除")) {
        return "删除课程";
      }
      if (String(course.reason || "").includes("增加")) {
        return "增加课程";
      }
      return course.reason || "课程异动";
    },
    getPaymentCourseChangeColor(course) {
      if (course.isDelete || String(course.reason || "").includes("删除")) {
        return "#fd5353";
      }
      if (course.reason == "缺勤") {
        return "#fd5353";
      }
      if (String(course.reason || "").includes("增加")) {
        return "#379941";
      }
      if (course.reason == "请假") {
        return "#474747";
      }
      return Number(course.changeFee) < 0 ? "#fd5353" : "#379941";
    },
    getPaymentCourseAmountColor(course) {
      return Number(course.changeFee) < 0 ? "#fd5353" : "#379941";
    },
    formatPaymentCourseChangeAmount(course) {
      const amount = Number(course.changeFee) || 0;
      if (amount < 0) return `-￥${Math.abs(amount)}`;
      if (amount > 0) return `+￥${amount}`;
      return "￥0";
    },
    // 获取学生课消记录, 已消课时
    async getStudentAttendedCourseRecord() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          studentId: this.selectedStudentId,
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/getStudentCourseRecord", params);
        if (resp1.data.code == "0000") {
          this.studentAttendedCourseList = resp1.data.data;
          console.log("获取学生课消记录:", this.studentAttendedCourseList);

          // 学生已消总课时
          this.studentAttendedHours = resp1.data.studentAttendedHours;

          // 当日课消金额
          this.todayCourseFee = 0;
          for (let i in this.studentAttendedCourseList) {
            if (this.studentAttendedCourseList[i].date == this.todayDate) {
              this.todayCourseFee = this.todayCourseFee + this.studentAttendedCourseList[i].fee;

              // console.log("this.todayCourseFee:", this.todayCourseFee);
              // console.log(
              //   "this.studentAttendedCourseList[i].fee:",
              //   this.studentAttendedCourseList[i].fee
              // );
            }
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 获取学生 课程变动，金额异动，总课时，未消课时, 未消课时的金额
    async getStudentChangeFee() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          studentId: this.selectedStudentId,
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/getStudentChangeFee", params);
        if (resp1.data.code == "0000") {
          this.studentChangeFee = resp1.data.data;
          console.log("this.studentChangeFee:", this.studentChangeFee);
          // console.log("this.studentChangeFee.changeCourse:", this.studentChangeFee.changeCourse);

          if (!this.studentChangeFee.changeFee) {
            this.studentChangeFee.changeFee = 0;
          }
          if (!this.studentChangeFee.courseNotAttendHours) {
            this.studentChangeFee.courseNotAttendHours = 0;
          }
          if (!this.studentChangeFee.notAttendFee) {
            this.studentChangeFee.notAttendFee = 0;
          }

          // 计算 未消课时 百分比
          // 防止分母0
          if (this.studentChangeFee.totalHours == 0 || !this.studentChangeFee.totalHours) {
            this.courseRestHourPercentage = 0;
          } else {
            this.courseRestHourPercentage = parseInt(this.studentChangeFee.courseNotAttendHours * 100 / this.studentChangeFee.totalHours);
          }
          // 百分比环形图
          this.courseHourDashArray = 2 * Math.PI * 40;
          this.courseHourDashOffset = this.courseHourDashArray * (1 - this.courseRestHourPercentage / 100);
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 获取学生 总缴费，总退费，剩余预存
    async getStudentBalance() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          studentId: this.selectedStudentId
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/getStudentBalance", params);
        if (resp1.data.code == "0000") {
          this.studentBalance = resp1.data.data;
          console.log("剩余预存this.studentBalance:", this.studentBalance);

          // 计算 剩余金额 百分比
          // 防止分母0
          if (this.studentBalance["totalAmount"] == 0) {
            this.balancePercentage = 0;
          } else {
            this.balancePercentage = Math.round((this.studentBalance.balance + this.studentChangeFee.notAttendFee) * 100 / this.studentBalance["totalAmount"]);
          }
          // 百分比环形图
          this.balanceDashArray = 2 * Math.PI * 40;
          this.balanceDashOffset = this.balanceDashArray * (1 - this.balancePercentage / 100);
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 获取班级列表
    async getClassList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/getClassList", params);
        if (resp1.data.code == "0000") {
          this.classList = resp1.data.data;

          // 部分字段json.parse()
          for (let i in this.classList) {
            this.classList[i].teacherIds = JSON.parse(this.classList[i].teacherIds);
            // 将 teacherId 倒序排列
            this.classList[i].teacherIds.sort((a, b) => b - a);
            this.classList[i].courses = JSON.parse(this.classList[i].courses);
            this.classList[i].periods = JSON.parse(this.classList[i].periods);
          }
          this.oriClassList = JSON.parse(JSON.stringify(this.classList));

          // console.log("获取班级列表 this.classList:", this.classList);

          // classId转换为className
          for (let i = 0; i < this.classList.length; i++) {
            this.classNames[this.classList[i].id] = this.classList[i].name;
            this.classType[this.classList[i].id] = this.classList[i].courseType;
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    // 获取顾问列表
    async getConsultantList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/enrollment/getSalesPerson", params);
        if (resp1.data.code == "0000") {
          this.consultantList = resp1.data.data;
          this.consultantNames = {};
          for (let i = 0; i < this.consultantList.length; i++) {
            this.consultantNames[this.consultantList[i].id] = this.consultantList[i].name;
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    addPaymentConsultant() {
      this.paymentConsultantForm = {
        name: "",
        phone: ""
      };
      this.showAddPaymentConsultant = true;
    },
    closeAddPaymentConsultant() {
      this.showAddPaymentConsultant = false;
    },
    async submitPaymentConsultant() {
      const consultantName = this.paymentConsultantForm.name.trim();
      const consultantPhone = this.paymentConsultantForm.phone.trim();
      if (!consultantName) {
        alert("请输入顾问姓名");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(consultantPhone)) {
        alert("请输入正确的11位手机号");
        return;
      }
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        const resp = await axios.post("https://backend.wonology.com/finance/consultantPerformance/addConsultant", {
          consultantName,
          consultantPhone,
          performanceTarget: {},
          institution: this.institution,
          isEdit: false
        });
        if (resp.data.code != "0000") {
          alert(resp.data.msg);
          return;
        }
        await this.getConsultantList();
        const consultantIndex = this.consultantList.findIndex(item => item.name === consultantName);
        if (consultantIndex >= 0) {
          this.selectedConsultantIndex = consultantIndex;
          this.handleConsultantChange();
        }
        this.showAddPaymentConsultant = false;
      } catch (error) {
        alert("添加顾问失败: " + error);
      } finally {
        loading.close();
      }
    },
    // 获取待处理金额异动的学生数
    async getStudentChangeFeePendingDealNum() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/getStudentChangeFeePendingDealNum", params);
        if (resp1.data.code == "0000") {
          this.pendingDealStudentIds = resp1.data.data;

          // console.log("this.pendingDealStudentIds:", this.pendingDealStudentIds);
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 添加学生
    addStudent() {
      this.editStudentFlag = false;
      this.studentName = "";
      this.studentGrade = "";
      this.studentSchool = "";
      this.studentPhone = "";
      this.studentParentPhone = "";
      this.studentParentPhones = [""];
      this.studentSource = "";
      this.showAddStudent = true;
    },
    addStudentParentPhoneInput() {
      this.studentParentPhones.push("");
    },
    removeStudentParentPhoneInput(index) {
      this.studentParentPhones.splice(index, 1);
    },
    getStudentParentPhones(student) {
      let parentPhones = student && student.parentPhones;
      if (typeof parentPhones === "string") {
        try {
          parentPhones = JSON.parse(parentPhones);
        } catch (error) {
          parentPhones = [parentPhones];
        }
      }
      if (!Array.isArray(parentPhones)) {
        parentPhones = [];
      }
      if (student && student.parentPhone) {
        parentPhones.unshift(student.parentPhone);
      }
      return [...new Set(parentPhones.map(phone => String(phone || "").trim()).filter(Boolean))];
    },
    normalizeStudentParentPhoneInputs() {
      return [...new Set(this.studentParentPhones.map(phone => String(phone || "").trim()).filter(Boolean))];
    },
    async addStudentConfirm() {
      // 如果是编辑学生
      if (this.editStudentFlag) {
        await this.editStudentConfirm();
        this.showAddStudent = false;
        return;
      }

      // 如果是添加学生
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        const parentPhones = this.normalizeStudentParentPhoneInputs();
        if (this.studentPhone || parentPhones.length) {} else {
          alert("学生或家长手机号至少填一个");
          return;
        }
        if (this.studentName && this.studentGrade && this.studentSchool && this.studentSource) {} else {
          alert("请填写完整信息");
          return;
        }
        let phoneValid = this.validatePhone(this.studentPhone);
        if (!phoneValid) {
          // alert("请输入正确的手机号");

          return;
        }
        for (const parentPhone of parentPhones) {
          phoneValid = this.validatePhone(parentPhone);
          if (!phoneValid) {
            return;
          }
        }
        let params = {
          name: this.studentName,
          grade: this.studentGrade,
          school: this.studentSchool,
          phone: this.studentPhone,
          parentPhone: parentPhones[0] || "",
          parentPhones,
          source: this.studentSource,
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/enrollment/addStudent", params);
        if (resp1.data.code == "0000") {
          this.showAddStudent = false;
          await this.getStudentList();
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    addStudentCancel() {
      this.showAddStudent = false;
      this.editStudentFlag = false;
    },
    // 校验手机号
    validatePhone(phone) {
      if (!phone) {
        phone = this.studentPhone;
      }

      // 如果是空，不判断
      if (!phone) {
        phone = this.studentPhone;
        return true;
      }

      // 手机号正则表达式 (11位数字，以1开头, 第二个必须是3-9，剩下9个数字)
      const mobileRegex = /^1[3-9]\d{9}$/;
      if (!mobileRegex.test(phone)) {
        this.phoneValidate = false;
        alert("请输入正确的手机号");
        return false;
      }
      this.phoneValidate = true;
      return true;
    },
    // 编辑学生
    editStudent(event, studentIndex) {
      event.stopPropagation();
      this.showAddStudent = true;
      this.editStudentFlag = true;

      // 赋值
      this.studentName = this.studentList[studentIndex].name;
      this.studentGrade = this.studentList[studentIndex].grade;
      this.studentSchool = this.studentList[studentIndex].school;
      this.studentPhone = this.studentList[studentIndex].phone;
      this.studentParentPhone = this.studentList[studentIndex].parentPhone;
      this.studentParentPhones = this.getStudentParentPhones(this.studentList[studentIndex]);
      if (this.studentParentPhones.length === 0) {
        this.studentParentPhones = [""];
      }
      this.studentSource = this.studentList[studentIndex].customer_source;
      this.selectedStudentId = this.studentList[studentIndex].id;
      this.selectedStudentIndex = studentIndex;
    },
    async editStudentConfirm() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        const parentPhones = this.normalizeStudentParentPhoneInputs();
        if (this.studentPhone || parentPhones.length) {} else {
          alert("学生或家长手机号至少填一个");
          return;
        }
        if (this.studentName && this.studentGrade && this.studentSchool && this.studentSource) {} else {
          alert("请填写完整信息");
          return;
        }
        let phoneValid = this.validatePhone(this.studentPhone);
        if (!phoneValid) {
          // alert("请输入正确的手机号");

          return;
        }
        for (const parentPhone of parentPhones) {
          phoneValid = this.validatePhone(parentPhone);
          if (!phoneValid) {
            return;
          }
        }
        let params = {
          studentId: this.selectedStudentId,
          name: this.studentName,
          grade: this.studentGrade,
          school: this.studentSchool,
          phone: this.studentPhone,
          parentPhone: parentPhones[0] || "",
          parentPhones,
          source: this.studentSource,
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/enrollment/editStudent", params);
        if (resp1.data.code == "0000") {
          await this.getStudentList();
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    // 搜索框搜索学生
    searchStudent() {
      //输入内容为空，返回空
      if (this.searchStudentStr.trim() === "") {
        this.filteredSuggestions = [];
      }
      //输入内容时 生成匹配的选项
      else {
        this.filteredSuggestions = this.suggestions.filter(item => item.toLowerCase().includes(this.searchStudentStr.toLowerCase()));
      }
      this.studentList = this.oriStudentList.filter(item => item.name.includes(this.searchStudentStr));
    },
    // 选择指定名字的学生
    async selectSuggestion(suggestion) {
      this.studentList = this.oriStudentList.filter(item => item.name == suggestion);
    },
    closeSuggestions() {
      // 延时关闭建议列表，确保点击事件先被处理
      setTimeout(() => {
        this.filteredSuggestions = [];
      }, 200);
    },
    // 选择学生
    async selectStudent(studentId) {
      this.selectedStudentId = studentId;
      this.selectedStudentIndex = this.oriStudentList.findIndex(item => item.id === studentId);

      // studentList恢复
      this.searchStudentStr = "";
      this.studentList = JSON.parse(JSON.stringify(this.oriStudentList));

      // 获取该学生的缴费记录
      await this.getStudentPaymentRecord();

      // 获取该学生的课消记录, 已消课时
      await this.getStudentAttendedCourseRecord();

      // 获取学生 总课时，金额异动，未消课时
      await this.getStudentChangeFee();

      // 获取学生 总缴费，总退费，剩余预存
      await this.getStudentBalance();
      this.showStudentList = false;
    },
    // 计算hh:mm-hh:mm 时间段长度的方法
    calculateTimeDuration(timeRange) {
      // timeRange 格式: "09:00-10:30"
      const [startTime, endTime] = timeRange.split("-");

      // 将时间字符串转换为分钟数
      const parseTimeToMinutes = timeStr => {
        const [hours, minutes] = timeStr.split(":").map(Number);
        return hours * 60 + minutes;
      };
      const startMinutes = parseTimeToMinutes(startTime);
      const endMinutes = parseTimeToMinutes(endTime);

      // 计算时间差（分钟）
      const durationMinutes = endMinutes - startMinutes;

      // 转换为小时和分钟
      const hours = Math.floor(durationMinutes / 60);
      const minutes = durationMinutes % 60;
      return {
        totalMinutes: durationMinutes,
        hours: hours,
        minutes: minutes,
        formatted: `${hours}小时${minutes}分钟`
      };
    },
    // 报名
    studentEnroll() {
      this.$router.push({
        path: "/enrollment",
        query: {
          studentId: this.selectedStudentId
        }
      });
    },
    // 预存
    prepay() {
      this.showPrepay = true;
    },
    async prepayConfirm() {
      if (this.prepayAmount === "" || this.prepayAmount <= 0) {
        alert("请输入预存金额");
        return;
      }
      if (this.prepayDonateAmount === "") {
        alert("请输入赠送金额");
        return;
      }
      this.showPayMethod = true;
      this.showPrepay = false;
    },
    prepayCancel() {
      this.showPrepay = false;
    },
    // 只能数字，每三位加逗号
    handlePrepayAmountInput(value) {
      if (value.trim() === "") {
        this.prepayAmount = "";
        this.formattedPrepayAmount = "";
        return;
      }

      // 使用正则表达式只保留数字
      const numericValue = value.replace(/[^\d]/g, "");
      // 更新数据
      this.prepayAmount = parseInt(numericValue);
      // console.log("this.prepayAmount:", this.prepayAmount);

      // 更新显示值（添加千位分隔符）
      if (numericValue) {
        const parts = numericValue.split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.formattedPrepayAmount = parts.join(".");
      } else {
        this.formattedPrepayAmount = "";
      }
    },
    // 只能数字，每三位加逗号
    handlePrepayDonateAmountInput(value) {
      if (value.trim() === "") {
        this.prepayDonateAmount = "";
        this.formattedPrepayDonateAmount = "";
        return;
      }

      // 使用正则表达式只保留数字
      const numericValue = value.replace(/[^\d]/g, "");
      // 更新数据
      this.prepayDonateAmount = parseInt(numericValue);
      // console.log("this.prepayDonateAmount:", this.prepayDonateAmount);

      // 更新显示值（添加千位分隔符）
      if (numericValue) {
        const parts = numericValue.split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.formattedPrepayDonateAmount = parts.join(".");
      } else {
        this.formattedPrepayDonateAmount = "";
      }
    },
    // 预存确认缴费
    async payConfirm() {
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        // console.log(
        //   "this.selectedConsultantIndex:",
        //   this.selectedConsultantIndex
        // );
        if (this.selectedConsultantIndex === "") {
          alert("请选择签约顾问");
          return;
        }
        let params = {
          studentId: this.selectedStudentId,
          consultantId: this.consultantList[this.selectedConsultantIndex].id,
          prepayTotalAmount: this.prepayAmount + this.prepayDonateAmount,
          prepayAmount: this.prepayAmount,
          payMethod: this.payMethod,
          paymentRemark: this.paymentRemark
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/studentPrepay", params);
        if (resp1.data.code == "0000") {
          // 获取学生 总缴费，总退费，剩余预存
          await this.getStudentBalance();

          // 获取该学生的缴费记录
          await this.getStudentPaymentRecord();
          this.showPayMethod = false;
          this.paySuccessAmount = this.prepayAmount + this.prepayDonateAmount;
          this.showPaySuccess = true;
        } else {
          console.error("调用studentEnrollClass出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("调用后端出错:", error);
        alert("调用后端出错: " + error);
      } finally {
        loading.close();
      }
    },
    payCancel() {
      this.showPayMethod = false;
      this.showPrepay = true;
    },
    paySuccessCancel() {
      this.showPaySuccess = false;
    },
    handleConsultantChange() {},
    // 转班
    async changeClass() {
      this.showTip = true;
      this.tipMessage = `功能暂未开放`;

      // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
      // 后面通过 this.tipResolver(value) 返回值
      const tipConfirmed = await new Promise(resolve => {
        this.tipResolver = resolve;
      });
      if (tipConfirmed === "confirm") {
        // 用户选择确认，继续执行

        this.showTip = false;
        // 重置变量
        this.tipMessage = "";
        this.tipNeedInput = false;

        // 不用做什么操作，返回
        return;
      } else {
        // 用户选择取消，返回

        return;
      }
    },
    // 停课
    async exitAllClass() {
      this.showTip = true;
      this.tipMessage = `功能暂未开放`;

      // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
      // 后面通过 this.tipResolver(value) 返回值
      const tipConfirmed = await new Promise(resolve => {
        this.tipResolver = resolve;
      });
      if (tipConfirmed === "confirm") {
        // 用户选择确认，继续执行

        this.showTip = false;
        // 重置变量
        this.tipMessage = "";
        this.tipNeedInput = false;

        // 不用做什么操作，返回
        return;
      } else {
        // 用户选择取消，返回

        return;
      }
    },
    // 退费
    // 点击退费申请按钮，显示选择要退费的班级页面
    async clickRefundClass() {
      // 临时 只给这个手机号开放退费功能，调试用
      if (this.userInfo.phone != "13166666666") {
        this.showTip = true;
        this.tipMessage = `功能暂未开放`;

        // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
        // 后面通过 this.tipResolver(value) 返回值
        const tipConfirmed = await new Promise(resolve => {
          this.tipResolver = resolve;
        });
        if (tipConfirmed === "confirm") {
          // 用户选择确认，继续执行

          this.showTip = false;
          // 重置变量
          this.tipMessage = "";
          this.tipNeedInput = false;

          // 不用做什么操作，返回
          return;
        } else {
          // 用户选择取消，返回

          return;
        }
      }
      if (!this.studentList[this.selectedStudentIndex].classIds) {
        alert("该学生没有报名班级");
        return;
      }
      let studentEnrollClassIds = JSON.parse(this.studentList[this.selectedStudentIndex].classIds);
      this.studentEnrollClassList = this.oriClassList.filter(item => studentEnrollClassIds.includes(item.id));

      // 判断今天在不在学生的报名班级的日期范围内
      let validData = [];
      for (let i = 0; i < this.studentEnrollClassList.length; i++) {
        let studentDateRange = JSON.parse(this.studentEnrollClassList[i].studentDateRange);
        let studentIds = JSON.parse(this.studentEnrollClassList[i].studentIds);
        let studentIndex = studentIds.indexOf(this.selectedStudentId);
        let dateRange = studentDateRange[studentIndex];
        let currentTime = moment().format("YYYY-MM-DD HH:mm:ss");
        if (currentTime >= dateRange[0] && currentTime <= dateRange[1]) {
          validData.push(this.studentEnrollClassList[i]);
        }
      }
      this.studentEnrollClassList = JSON.parse(JSON.stringify(validData));

      // 判断班级是否正在申请退费
      await this.ifClassApplyRefund();
      this.showSelectRefundClass = true;
    },
    // 判断班级是否正在申请退费
    async ifClassApplyRefund() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          studentId: this.selectedStudentId,
          classList: this.studentEnrollClassList
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/ifClassApplyRefund", params);
        if (resp1.data.code == "0000") {
          this.studentEnrollClassList = resp1.data.data;
          this.pendingRefundClassIds = resp1.data.pendingRefundClassIds;
          console.log("this.studentEnrollClassList:", this.studentEnrollClassList);
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    // 选择退费班级单选框
    selectedRefundClassIdsChange() {
      this.selectedRefundClassIds = [this.selectedRefundClassId];
    },
    // 点击班级名，也是选择退费的班级
    selectRefundClass(classId) {
      // if (this.selectedRefundClassIds.includes(classId)) {
      //   this.selectedRefundClassIds = this.selectedRefundClassIds.filter(
      //     (item) => item !== classId
      //   );
      // } else {
      //   this.selectedRefundClassIds.push(classId);
      // }

      this.selectedRefundClassId = classId;
      this.selectedRefundClassIds = [classId];
    },
    // 选择退费的班级，计算退费金额
    async selectRefundClassConfirm() {
      // 获取要退费的班级，费用详细
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        if (this.selectedRefundClassIds.length == 0) {
          alert("请选择退费班级");
          return;
        }
        let params = {
          studentId: this.selectedStudentId,
          refundClassIds: this.selectedRefundClassIds,
          institution: this.institution,
          useOriFee: this.useOriFee
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/getRefundClassDetail", params);
        if (resp1.data.code == "0000") {
          this.refundClassCourseTecherFeeObj = resp1.data.data;

          // console.log(
          //   "this.refundClassCourseTecherFeeObj:",
          //   this.refundClassCourseTecherFeeObj
          // );

          this.refundCourses = resp1.data.refundCourses;
          this.refundConcreteDateTime = resp1.data.refundConcreteDateTime;
          console.log("待退的课 this.refundCourses:", this.refundCourses);
          console.log("this.refundClassCourseTecherFeeObj:", this.refundClassCourseTecherFeeObj);

          // 计算退费金额
          this.refundTotalFee = 0;
          this.refundRemainingTotal = 0;
          this.refundDonateAmount = 0;
          for (let classId in this.refundClassCourseTecherFeeObj) {
            for (let course in this.refundClassCourseTecherFeeObj[classId]) {
              for (let teacherId in this.refundClassCourseTecherFeeObj[classId][course]) {
                for (let fee in this.refundClassCourseTecherFeeObj[classId][course][teacherId]) {
                  const row = this.refundClassCourseTecherFeeObj[classId][course][teacherId][fee];
                  this.refundTotalFee += Number(row.refundFee) || 0;
                  this.refundRemainingTotal += Number(row.remainingAmount) || 0;
                }
              }
            }
          }
          this.refundTotalFee = parseFloat(this.refundTotalFee.toFixed(2));
          this.refundRemainingTotal = parseFloat(this.refundRemainingTotal.toFixed(2));
          this.refundDonateAmount = parseFloat(Math.max(0, this.refundRemainingTotal - this.refundTotalFee).toFixed(2));
          this.refundRealFee = this.refundTotalFee;
          this.showRefundDetail = true;
          this.showSelectRefundClass = false;
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    selectRefundClassCancel() {
      this.showSelectRefundClass = false;
    },
    //
    // 限制只能输入浮点数，最多两位小数
    handleFloatInput(type, args, value) {
      // 允许空值
      if (value === "") {
        if (type == "退费") {
          // 手续费
          if (args[0] == "") {
            this.refundServiceFee = 0;

            // this.refundServiceFeeChange();
          }
          // 优惠单价
          else {
            this.refundClassCourseTecherFeeObj[args[0]][args[1]][args[2]][args[3]].realFee = 0;

            // 修改优惠单价，重新计算退费总额, 实退
            // this.courseRealFeeChange();
          }
        }
        if (type == "金额异动") {
          this.studentChangeFee.changeCourse[args[0]].realFee = 0;
        }
        return;
      }

      // 正则表达式匹配数字和最多两位小数
      const regex = /^\d*\.?\d{0,2}$/;

      // 如果符合格式则不处理
      if (regex.test(value)) {
        // 去除前导零，但保留一个小数点前的零（如 0.5 的情况）
        if (value.startsWith("0") && value.length > 1 && value.charAt(1) !== ".") {
          value = value.replace(/^0+/, "") || "0";
        }
      }
      // 不符合格式
      else {
        // 移除最后一个无效字符
        value = value.slice(0, -1);

        // 去除前导零
        if (value.startsWith("0") && value.length > 1 && value.charAt(1) !== ".") {
          value = value.replace(/^0+/, "") || "0";
        }
      }

      // 更新value
      if (type == "退费") {
        // 手续费
        if (args[0] == "") {
          this.refundServiceFee = value;

          // this.refundServiceFeeChange();
        }
        // 优惠单价
        else {
          this.refundClassCourseTecherFeeObj[args[0]][args[1]][args[2]][args[3]].realFee = value;

          // 修改优惠单价，重新计算退费总额, 实退
          // this.courseRealFeeChange();
        }
      }
      if (type == "金额异动") {
        this.studentChangeFee.changeCourse[args[0]].realFee = value;
      }
    },
    // 修改优惠单价，重新计算退费总额, 实退
    courseRealFeeChange(type) {
      console.log("courseRealFeeChange");
      if (type == "退费") {
        this.refundTotalFee = 0;
        for (let classId in this.refundClassCourseTecherFeeObj) {
          for (let course in this.refundClassCourseTecherFeeObj[classId]) {
            for (let teacherId in this.refundClassCourseTecherFeeObj[classId][course]) {
              for (let fee in this.refundClassCourseTecherFeeObj[classId][course][teacherId]) {
                let hours = parseFloat((this.refundClassCourseTecherFeeObj[classId][course][teacherId][fee].restCourseMinutes / 60).toFixed(2));
                this.refundTotalFee += hours * this.refundClassCourseTecherFeeObj[classId][course][teacherId][fee].realFee;
              }
            }
          }
        }
        this.refundTotalFee = parseFloat(this.refundTotalFee.toFixed(2));
        this.refundRealFee = this.refundTotalFee - this.refundServiceFee;
        this.refundRealFee = parseFloat(this.refundRealFee.toFixed(2));
      }
      if (type == "金额异动") {
        this.studentChangeFee.changeFee = 0;
        for (let i in this.studentChangeFee.changeCourse) {
          let minutes = this.calculateTimeDuration(this.studentChangeFee.changeCourse[i].period).totalMinutes;

          // 增加排课，
          if (this.studentChangeFee.changeCourse[i].reason == "增加排课") {
            let changeFee = parseFloat((0 - this.studentChangeFee.changeCourse[i].realFee * minutes / 60).toFixed(2));
            this.studentChangeFee.changeCourse[i].changeFee = changeFee;
            this.studentChangeFee.changeFee = this.studentChangeFee.changeFee + this.studentChangeFee.changeCourse[i].changeFee;
          }
          // 删除排课 或 考勤
          else {
            // 不让改realFee，不需要重新计算, 还是使用本来的changeFee
            this.studentChangeFee.changeFee = this.studentChangeFee.changeFee + this.studentChangeFee.changeCourse[i].changeFee;
          }
        }

        // 保留2位小数
        this.studentChangeFee.changeFee = parseFloat(this.studentChangeFee.changeFee.toFixed(2));
      }
    },
    // 选择按原价结算, 重新计算退费详细
    async selectUseOriFeeChange() {
      await this.selectRefundClassConfirm();
    },
    // 点击 按原价结算 文字， 也是选择
    clickUseOriFeeWord() {
      this.useOriFee = !this.useOriFee;
      this.selectUseOriFeeChange();
    },
    // 修改手续费，重新计算实退
    refundServiceFeeChange() {
      this.refundRealFee = this.refundTotalFee - this.refundServiceFee;
      this.refundRealFee = parseFloat(this.refundRealFee.toFixed(2));
    },
    // 点击申请退费, 生成退费申请
    async refundConfirm() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        if (this.refundTotalFee < 0) {
          alert("退费金额小于0, 请先去金额异动页面处理");
          return;
        }
        if (this.refundRealFee < 0) {
          alert("实退金额小于0, 请设置合适的手续费");
          return;
        }
        let params = {
          studentId: this.selectedStudentId,
          refundClassCourseTecherFeeObj: this.refundClassCourseTecherFeeObj,
          refundCourses: this.refundCourses,
          refundServiceFee: this.refundServiceFee,
          refundTotalFee: this.refundTotalFee,
          institution: this.institution,
          username: this.userInfo.name,
          useOriFee: this.useOriFee,
          refundConcreteDateTime: this.refundConcreteDateTime,
          refundReason: this.refundReason,
          refundServiceFeeReason: this.refundServiceFeeReason
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/refundApply", params);
        if (resp1.data.code == "0000") {
          alert("退费申请已提交, 等待审核");
          this.showRefundDetail = false;
          this.showSelectRefundClass = false;

          // 模拟审批通过
          // await this.getRefundApprovalList();
          // await this.approveRefund();
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    // 取消退费
    refundCancel() {
      this.showRefundDetail = false;
    },
    // 获取退费申请 待审批列表
    async getRefundApprovalList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/getPendingRefundApply", params);
        if (resp1.data.code == "0000") {
          this.pendingRefundApplyList = resp1.data.data;
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 模拟退费审批通过
    async approveRefund() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          refundApplyId: this.pendingRefundApplyList[0].id
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/approveRefundApply", params);
        if (resp1.data.code == "0000") {
          await this.getClassList();

          // 获取学生 总课时，金额异动
          await this.getStudentChangeFee();
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 点击切换学生按钮，到学生列表页面
    toStudentList() {
      this.showStudentList = true;
    },
    // 点击div触发select下拉框展开
    clickStudentStatusSelect() {
      // 通过 this.$refs 获取 el-select 实例
      const select = this.$refs.studentStatusSelectRef;
      if (select) {
        // 先聚焦（可选，但推荐）
        select.focus();
        // 调用 toggleMenu 展开/收起下拉菜单
        select.toggleMenu();
      }
    },
    // 筛选学生状态
    handleStudentStatusChange() {
      this.studentList = this.oriStudentList.filter(item => {
        if (this.selectedStudentStatus === "全部") {
          return true;
        }
        if (this.selectedStudentStatus === "在读学生") {
          return item.isActive === 1;
        }
        if (this.selectedStudentStatus === "结课学生") {
          return item.isActive === 0;
        }
      });
    },
    // 查看金额异动解释
    clickChangeFeeExplain() {
      this.showChangeFeeExplain = true;
    },
    cancelChangeFeeExplain() {
      this.showChangeFeeExplain = false;
    },
    // 查看金额异动详情
    seeChangeFeeDetail() {
      this.showChangeFeeDetail = true;
    },
    cancelChangeFeeDetail() {
      this.showChangeFeeDetail = false;
    },
    // 点击补缴费用
    async dealChangeFee() {
      // 如果金额异动小于0，要补缴费用
      if (this.studentChangeFee.changeFee < 0) {
        // 选择支付方式
        this.showChangeFeePayMethod = true;
        return;
      }
      // 如果金额异动等于0
      if (this.studentChangeFee.changeFee == 0) {
        // 没有变化的课程
        if (this.studentChangeFee.changeCourse.length == 0) {
          this.showTip = true;
          this.tipMessage = `没有金额异动`;

          // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
          // 后面通过 this.tipResolver(value) 返回值
          const tipConfirmed = await new Promise(resolve => {
            this.tipResolver = resolve;
          });
          if (tipConfirmed === "confirm") {
            // 用户选择确认，继续执行

            this.showTip = false;
            // 重置变量
            this.tipMessage = "";
            this.tipNeedInput = false;

            // 不用做什么操作，返回
            return;
          } else {
            // 用户选择取消，返回

            return;
          }
        }
        // 有变化的课程
        else {
          this.showTip = true;
          this.tipMessage = `是否要调整业绩归属？`;

          // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
          // 后面通过 this.tipResolver(value) 返回值
          const tipConfirmed = await new Promise(resolve => {
            this.tipResolver = resolve;
          });
          if (tipConfirmed === "confirm") {
            // 用户选择确认，继续执行

            this.showTip = false;
            // 重置变量
            this.tipMessage = "";
            this.tipNeedInput = false;

            //
          } else {
            // 用户选择取消，返回

            return;
          }

          // 选择支付方式
          this.showChangeFeePayMethod = true;
        }
      }
      // 如果金额异动大于0，退到余额
      else {
        this.showTip = true;
        this.tipMessage = `当前金额异动大于0，可退费用到余额，是否继续？`;

        // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
        // 后面通过 this.tipResolver(value) 返回值
        const tipConfirmed = await new Promise(resolve => {
          this.tipResolver = resolve;
        });
        if (tipConfirmed === "confirm") {
          // 用户选择确认，继续执行

          this.showTip = false;
          // 重置变量
          this.tipMessage = "";
          this.tipNeedInput = false;
        } else {
          // 用户选择取消，返回

          return;
        }

        // 如果确定退回余额，加预存记录
        //loading界面
        const loading = ElLoading.service({
          lock: true,
          text: "处理中...",
          background: "rgba(0, 0, 0, 0.7)"
        });
        try {
          let params = {
            changeCourse: this.studentChangeFee.changeCourse,
            studentId: this.selectedStudentId,
            changeFee: 0 - this.studentChangeFee.changeFee
          };
          let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/payChangeFee", params);
          if (resp1.data.code == "0000") {
            this.showChangeFeeDetail = false;

            // 更新金额异动
            await this.getStudentChangeFee();
            // 更新缴费列表
            await this.getStudentPaymentRecord();
            // 更新剩余预存
            await this.getStudentBalance();
          } else {
            console.error("调用后端出错:", resp1.data.msg);
            alert("调用后端出错: " + resp1.data.msg);
          }
        } catch (error) {
          console.error("catch error:", error);
          alert("catch error");
        } finally {
          loading.close();
        }
      }
    },
    payMethodChange() {
      if (this.payMethod == "余额") {
        this.selectUseBalancePay = true;
      } else {
        this.selectUseBalancePay = false;
        this.balanceRemainPayMethod = this.payMethod;
      }
    },
    // 点击支付方式的文字，也是选择
    clickPayMethodWord(payMethod) {
      // console.log("payMethod:", payMethod);
      this.payMethod = payMethod;
      this.payMethodChange();
    },
    // 金额异动 确认缴费
    async payChangeFeeConfirm() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let consultantId;
        const changePayAmount = 0 - this.studentChangeFee.changeFee;
        const isPartialBalancePay = this.selectUseBalancePay && Number(this.studentBalance.balance) < Number(changePayAmount);

        // 直接缴费，或余额不足补差额，需要选择顾问
        if (!this.selectUseBalancePay || isPartialBalancePay) {
          if (!this.consultantList[this.selectedConsultantIndex]) {
            alert("请选择签约顾问");
            return;
          }
          consultantId = this.consultantList[this.selectedConsultantIndex].id;
        }
        let params = {
          changeCourse: this.studentChangeFee.changeCourse,
          studentId: this.selectedStudentId,
          changeFee: 0 - this.studentChangeFee.changeFee,
          useBalancePay: this.selectUseBalancePay,
          consultantId: consultantId,
          payMethod: this.payMethod,
          balanceRemainPayMethod: this.balanceRemainPayMethod,
          paymentRemark: this.paymentRemark
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/payChangeFee", params);
        if (resp1.data.code == "0000") {
          this.showChangeFeeDetail = false;
          this.showChangeFeePayMethod = false;
          this.paySuccessAmount = 0 - this.studentChangeFee.changeFee;
          this.showPaySuccess = true;

          // 更新金额异动
          await this.getStudentChangeFee();
          // 更新缴费列表
          await this.getStudentPaymentRecord();
          // 更新剩余预存
          await this.getStudentBalance();
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    payChangeFeeCancel() {
      this.showChangeFeePayMethod = false;
    },
    // 提示弹窗 取消
    closeTip() {
      this.showTip = false;
      // 重置变量
      this.tipMessage = "";
      this.tipNeedInput = false;
      if (this.tipResolver) {
        // 传输结果
        this.tipResolver("cancel");
        this.tipResolver = null;
      }
    },
    confirmTip() {
      // this.showTip = false;
      // // 重置变量
      // this.tipMessage = "";
      // this.tipNeedInput = false;

      if (this.tipResolver) {
        // 传输结果
        this.tipResolver("confirm");
        this.tipResolver = null;
      }
    }
  }
};